import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f9eda83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative mx-auto w-4/6" }
const _hoisted_2 = { class: "flex items-center rounded-full border bg-white pl-3 shadow-sm" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  type: "button",
  class: "absolute right-1 rounded-full p-1 hover:bg-gray-200 hover:text-blue-10 md:right-2"
}
const _hoisted_5 = {
  key: 1,
  type: "button",
  "data-tip": "আমাদের কোর্সসমূহ",
  class: "tooltip tooltip-left absolute right-1 rounded-full p-1 hover:bg-gray-200 hover:font-semibold hover:text-blue-10 md:right-2"
}
const _hoisted_6 = {
  key: 0,
  class: "scroll-light absolute z-10 mt-2 max-h-[500px] w-full overflow-auto rounded-lg bg-white shadow-lg"
}
const _hoisted_7 = ["onClick", "onKeydown"]
const _hoisted_8 = {
  key: 1,
  class: "mx-auto h-[200px] w-full max-w-sm rounded-md border border-blue-300 p-4 shadow"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex animate-pulse space-x-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-1 space-y-6 py-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-2 rounded bg-slate-300" }),
    /*#__PURE__*/_createElementVNode("div", { class: "space-y-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-3 gap-4" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 h-2 rounded bg-slate-300" }),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 h-2 rounded bg-slate-300" }),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 h-2 rounded bg-slate-300" }),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 h-2 rounded bg-slate-300" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "h-2 rounded bg-slate-300" }),
      /*#__PURE__*/_createElementVNode("div", { class: "h-2 rounded bg-slate-300" })
    ])
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "p-4 text-gray-500"
}
const _hoisted_12 = { class: "flex flex-col rounded-md px-4 pb-3 pt-1" }
const _hoisted_13 = ["onClick"]

import {
  Bars3BottomLeftIcon,
  MagnifyingGlassIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import axios from 'axios';
import type {
  GetCoursesDto,
} from 'dto';
import {
  debounce,
} from 'lodash';
import type {
  ChangeTypeOfKeys,
} from 'types';
import {
  ref,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import FullPageButton from '@/components/Helper/FullPageButton.vue';
import {
  CONSTANTS,
  handleAxiosError,
} from '@/helpers';
import {
  useStore,
} from '@/store';

export interface ICourseInfo {
  _id: string;
  title: string;
  slug: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchCourse',
  setup(__props) {


const { features } = useStore.backend.clientCompany.subscriptionSettings;

const ourCourseOptions = [
  CONSTANTS.ROUTE.allOurCourses,
  CONSTANTS.ROUTE.allClass9Courses,
  CONSTANTS.ROUTE.allClass10Courses,
  CONSTANTS.ROUTE.allSSCCourses,
  CONSTANTS.ROUTE.allHSCCourses,
  CONSTANTS.ROUTE.allAdmissionCourses,
  CONSTANTS.ROUTE.allSkillDevCourses,
  CONSTANTS.ROUTE.allRunningCourses,
  CONSTANTS.ROUTE.allUpcomingCourses,
  CONSTANTS.ROUTE.freeCourses,
];

const selectedOptionFromAllCourse = ref<string>('');

const isAllCourseOpen = ref(false);

const router = useRouter();
const courses = ref<ICourseInfo[]>([]);
const searchText = ref('');
const searchCache = new Map<string, ICourseInfo[]>();

const isLoading = ref(false);

const _getCourseInfo = debounce((): Promise<void> => _getCourses(), 1000);

function handleSearchText(e: Event): void {
  searchText.value = (e.target as HTMLInputElement).value;
  isAllCourseOpen.value = false;
  isLoading.value = true;

  _getCourseInfo();
}

function onAllCourseDropdownClick(option: string, targetRoute: string): void {
  isAllCourseOpen.value = !isAllCourseOpen.value;
  selectedOptionFromAllCourse.value = option;

  router.push(targetRoute);
}

function onCourseClick(slug: string): void {
  searchText.value = '';
  router.push(`/course/${slug}`);
}

async function _getCourses(): Promise<void> {
  const text = searchText.value.trim();

  if (!text || searchCache.has(text)) {
    courses.value = searchCache.get(text) || [];
    isLoading.value = false;

    return;
  }

  try {
    const params: ChangeTypeOfKeys<GetCoursesDto, 'filterBy' | 'fields', string | undefined> = {
      allowBatch: features.batchManagement ? '1' : '0',
      search: encodeURIComponent(text),
      website: window.location.origin,
      filterBy: ['title', 'summary', 'program', 'slug'].join(','),
      fields: ['title', 'slug'].join(','),
    };

    const response = await axios.get<{ docs: ICourseInfo[]}>(
      '/public/courses',
      {
        params,
      },
    );

    courses.value = response.data.docs;

    searchCache.set(text, courses.value);
  } catch (e: any) {
    handleAxiosError(e);
  } finally {
    isLoading.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MagnifyingGlassIcon), { class: "size-5 md:size-6 lg:size-7" }),
      _createElementVNode("input", {
        value: searchText.value,
        type: "text",
        class: "w-full rounded-full p-2 pr-10 text-sm focus:outline-none md:text-lg",
        placeholder: "কোর্স খুঁজে দেখো...",
        onInput: handleSearchText
      }, null, 40, _hoisted_3),
      (searchText.value)
        ? (_openBlock(), _createElementBlock("button", _hoisted_4, [
            _createVNode(_unref(XMarkIcon), {
              class: "size-5 md:size-6",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (searchText.value = ''))
            })
          ]))
        : (_openBlock(), _createElementBlock("button", _hoisted_5, [
            _createVNode(_unref(Bars3BottomLeftIcon), {
              class: "size-5 md:size-6 lg:size-7",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAllCourseOpen.value = !isAllCourseOpen.value))
            })
          ]))
    ]),
    _createVNode(_Transition, { name: "pulse" }, {
      default: _withCtx(() => [
        (searchText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (courses.value.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(courses.value, (course, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${course.title}-${index}`,
                      type: "button",
                      class: "search-course-option-btn",
                      onClick: ($event: any) => (onCourseClick(course.slug)),
                      onKeydown: ($event: any) => (onCourseClick(course.slug))
                    }, _toDisplayString(course.title), 41, _hoisted_7))
                  }), 128))
                : (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, " কোনো কোর্স পাওয়া যায়নি "))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (isAllCourseOpen.value)
        ? (_openBlock(), _createBlock(FullPageButton, {
            key: 0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isAllCourseOpen.value = false))
          }))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        class: "absolute",
        name: "slide-down"
      }, {
        default: _withCtx(() => [
          (isAllCourseOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["absolute right-0 z-10 mt-1 w-44 rounded-md bg-white shadow shadow-gray-500 md:w-48 lg:w-52", { 'transition ease-in': isAllCourseOpen.value }])
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ourCourseOptions, (menu, index) => {
                    return _createElementVNode("button", {
                      key: `${menu.alternateTitle}-${index}`,
                      type: "button",
                      class: "our-course-option-btn",
                      onClick: ($event: any) => (onAllCourseDropdownClick(menu.alternateTitle, menu.path))
                    }, _toDisplayString(menu.alternateTitle), 9, _hoisted_13)
                  }), 64))
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})